<div class="grid grid-no-tb-gutter flex align-items-center">
    <div  class="col" style="min-width: 100px;">
        {{ row.lastExecutionDate}}
    </div>
    <div class="col flex-w-auto flex align-items-center">
        <svg
        class="icon-delete"
        (click)="removeCronJob(row.id)"
        width="21"
        height="22"
        viewBox="0 0 21 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7157 19.7493C9.53003 19.7493 8.37415 19.7362 7.23053 19.7125C5.76753 19.6837 4.75515 18.7352 4.58978 17.2372C4.31415 14.7522 3.84253 8.8949 3.83815 8.83628C3.8084 8.4749 4.0779 8.15815 4.43928 8.12928C4.7954 8.11965 5.1174 8.3699 5.14628 8.7304C5.15065 8.7899 5.6214 14.627 5.8944 17.0928C5.98803 17.9442 6.4474 18.3834 7.25765 18.4C9.44515 18.4464 11.6773 18.449 14.0835 18.4053C14.9445 18.3887 15.41 17.9582 15.5063 17.0867C15.7775 14.6419 16.25 8.7899 16.2553 8.7304C16.2842 8.3699 16.6035 8.1179 16.9614 8.12928C17.3228 8.15903 17.5923 8.4749 17.5634 8.83628C17.5582 8.89578 17.0839 14.7679 16.8109 17.231C16.6412 18.7597 15.6314 19.6898 14.1072 19.7178C12.9408 19.7379 11.8155 19.7493 10.7157 19.7493Z"
        fill="#F13E3E"
        />
        <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.1194 6.61523H3.28113C2.91888 6.61523 2.62488 6.32123 2.62488 5.95898C2.62488 5.59673 2.91888 5.30273 3.28113 5.30273H18.1194C18.4816 5.30273 18.7756 5.59673 18.7756 5.95898C18.7756 6.32123 18.4816 6.61523 18.1194 6.61523Z"
        fill="#F13E3E"
        />
        <path
        fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.2602 6.61537C14.2645 6.61537 13.4 5.90575 13.204 4.92925L12.9914 3.86525C12.9467 3.70337 12.7621 3.5625 12.5521 3.5625H8.84823C8.63823 3.5625 8.45361 3.70337 8.40023 3.9055L8.19636 4.92925C8.00123 5.90575 7.13586 6.61537 6.14011 6.61537C5.77786 6.61537 5.48386 6.32137 5.48386 5.95912C5.48386 5.59687 5.77786 5.30287 6.14011 5.30287C6.51286 5.30287 6.83661 5.03687 6.91011 4.67112L7.12273 3.60712C7.33886 2.79162 8.04498 2.25 8.84823 2.25H12.5521C13.3554 2.25 14.0615 2.79162 14.2689 3.56775L14.4911 4.67112C14.5637 5.03687 14.8875 5.30287 15.2602 5.30287C15.6225 5.30287 15.9165 5.59687 15.9165 5.95912C15.9165 6.32137 15.6225 6.61537 15.2602 6.61537Z"
            fill="#F13E3E"
            />
        </svg>
    </div>
</div>